export default "__VITE_ASSET__C8TPFTKo__"